/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 294);
/******/ })
/************************************************************************/
/******/ ({

/***/ 294:
/***/ (function(module, exports) {

(function () {
	//noinspection BadExpressionStatementJS
	"strict mode";

	if (window.Magellan) return;

	var ID_PREFIX = 'rgi-magellan-frame-';
	var EVENT_PREFIX = 'rgi-magellan-';
	var LOCALSTORAGE_PREFIX = 'rgiMagellan';
	var SCRIPT_NAME = 'magellan.min.js';
	var DEFAULT = {target: 'magellan'};
	var FIRST_LOAD = {
		'ages':     null, 'fromDate': null, 'toDate': null, 'minDays': null, 'maxDays': null,
		'regionId': null, 'cityId': null
	};
	var MIN_SIZE = {width: 900, height: 460};

	var frameNumber = 1;
	var frames = {};
	var user = undefined;
	var userInfoCallback = undefined;

	var path = document.querySelector('script[src$="' + SCRIPT_NAME + '"]').getAttribute('src');
	var a = document.createElement('a');
	a.href = path;
	// FIXME: debug only
	var baseUrl = (a.protocol ? a.protocol + '//' : '') + a.hostname + (a.port ? ':' + a.port : '');
	// var baseUrl = 'http://localhost:6543/demo';
	var match = window.location.href.match('localhost[^\/]*\/([^\/]+)');
	if (match) baseUrl = baseUrl.replace('8040', '6543') + '/' + match[1];

	var getFrameId = function () {
		return ID_PREFIX + frameNumber++;
	};

	var startsWith = function (str, prefix) {
		return str.lastIndexOf(prefix, 0) === 0;
	};

	var broadcast = function (message) {
		for (var i in frames)
			if (frames[i].el.contentWindow)
				frames[i].el.contentWindow.postMessage(JSON.stringify(message), baseUrl);
	};

	var addServiceFrame = function (url) {
		var frame = document.createElement('iframe');
		frame.src = baseUrl + '/' + url;
		frame.scrolling = 'no';
		frame.setAttribute('style', 'display: none !important;');
		document.body.appendChild(frame);
	};

	var showFixed = function (url, name, parentId) {
		var frameId = parentId ? parentId + '-' + name : ID_PREFIX + name;
		if (frameId in frames) return;
		var frame = document.createElement('iframe');
		frame.id = frameId;
		frame.src = url + '?id=' + frame.id + (parentId ? frames[parentId].settings : '');
		// frame.scrolling = 'no';
		frame.setAttribute('style', 'position: fixed !important;visibility: visible !important;display: block !important;left: 0px !important;top: 0px !important;height: 100% !important;width: 100% !important;border: 0px none !important;z-index: 100000000 !important;');
		document.body.appendChild(frame);
		frames[frame.id] = {
			el:       document.getElementById(frame.id),
			settings: (parentId ? frames[parentId].settings : '')
		};
	};

	var showPopup = function (url, name, parentId, top, left, data) {
		var frameId = parentId ? parentId + '-' + name : ID_PREFIX + name;
		if (frameId in frames) return;
		var frame = document.createElement('iframe');
		frame.id = frameId;
		frame.src = url + '?id=' + frame.id + '&data=' + JSON.stringify(data) + (parentId ? frames[parentId].settings : '');
		frame.scrolling = 'no';
		frame.setAttribute('style',
			'position: absolute !important;' +
			'visibility: visible !important;' +
			'display: block !important;' +
			'left: ' + left + 'px !important;' +
			'top: ' + top + 'px !important;' +
			'border: 0px none !important;' +
			'z-index: 100000000 !important;');
		document.body.appendChild(frame);
		frames[frame.id] = {
			el:       document.getElementById(frame.id),
			settings: (parentId ? frames[parentId].settings : '')
		};
	};

	var showPopupByOffset = function (url, name, parentId, top, left, data) {
		var frameId = parentId ? parentId + '-' + name : ID_PREFIX + name;
		if (frameId in frames) return;

		var anchorOffset = {left: 0, top: 0};
		var anchor = frames[parentId];

		if (!!anchor) {
			var rect = anchor.el.getBoundingClientRect();
			anchorOffset = {
				left: rect.left + document.body.scrollLeft,
				top:  rect.top + document.body.scrollTop
			};
		}


		var frame = document.createElement('iframe');
		frame.id = frameId;
		frame.src = url + '?id=' + frame.id + '&data=' + JSON.stringify(data) + (parentId ? frames[parentId].settings : '');
		frame.scrolling = 'no';

		frame.setAttribute('style',
			'position: absolute !important;' +
			'visibility: visible !important;' +
			'display: block !important;' +
			'left: ' + (anchorOffset.left + left) + 'px !important;' +
			'top: ' + (anchorOffset.top + top) + 'px !important;' +
			'border: 0px none !important;' +
			'z-index: 100000000 !important;');

		document.body.appendChild(frame);
		frames[frame.id] = {
			el:       document.getElementById(frame.id),
			settings: (parentId ? frames[parentId].settings : '')
		};
	};

	var showImage = function (url) {
		var imageHtml = '<div style="text-align: center; height: 100%; overflow: auto;"><img style="box-shadow: 0 0 8px 0 rgba(0,0,0,.3); max-width: 800px; margin: 50px 0;" src="' + url + '" alt=""/></div>';
		var image = document.createElement('div');
		image.setAttribute('style', 'z-index: 100000000 !important;position: fixed !important;width: 100% !important;height: 100% !important;top: 0 !important;left: 0 !important;background: rgba(0, 0, 0, 0.3) !important;cursor: pointer !important;');
		image.innerHTML = imageHtml;
		image.onclick = function () {
			document.body.style.overflow = 'auto';
			document.body.removeChild(image);
		};
		document.body.appendChild(image);
		document.body.style.overflow = 'hidden';
	};

	var receiveMessage = function (event) {
		if (!startsWith(event.origin, baseUrl) && !startsWith(baseUrl, event.origin)) return;
		try {
			var data = JSON.parse(event.data);
		}
		catch (ex) {
			return;
		}
		if (data.type == 'location') {
			window.location = data.url;
		}
		else if (data.type == 'go') {
			var url = data.url + '?reloaded=true&id=' + data.id + frames[data.id].settings;
			frames[data.id].el.src = data.data ? url + '&data=' + data.data : url;
		}
		else if (data.type == 'all') {
			// frames[data.id].settings = frames[data.id].settings.replace(/campOfferId=\d+/, '');
			frames[data.id].el.src = baseUrl + '?id=' + data.id + frames[data.id].settings;
		}
		else if (data.type == 'resize') {
			var position = frames[data.id].el.style.position;
			if (position === 'fixed') return;
			frames[data.id].el.style.width = (position ? data.width : Math.max(data.width, MIN_SIZE.width)) + "px";
			frames[data.id].el.style.height = (position ? data.height : Math.max(data.height, MIN_SIZE.height)) + "px";
		}
		else if (data.type == 'fixed') {
			document.body.style.overflow = 'hidden';
			showFixed(data.url, data.name, data.id);
		}
		else if (data.type == 'popup') {
			showPopup(data.url, data.name, data.id, data.top, data.left, data.data);
		}
		else if (data.type == 'popup_offset') {
			showPopupByOffset(data.url, data.name, data.id, data.top, data.left, data.data);
		}
		else if (data.type == 'image') {
			showImage(baseUrl + data.url);
		}
		else if (data.type == 'close') {
			document.body.style.overflow = 'auto';
			document.body.removeChild(frames[data.id].el);
			delete frames[data.id];
		}
		else if (data.type == 'forward') {
			broadcast(data.message);
		}
		else if (data.type == 'event') {
			window.dispatchEvent(new CustomEvent(EVENT_PREFIX + data.name, {detail: data.data || {}}));
		}
		else if (data.type == 'user-info') {
			user = data.data;
			userInfoCallback(data.data);
		}
	};
	window.addEventListener('message', receiveMessage, false);
	window.addEventListener(EVENT_PREFIX + 'logout', function () {
		broadcast({type: 'logout'});
		user = null;
	});
	window.addEventListener(EVENT_PREFIX + 'login', function (event) {
		broadcast({type: 'login', data: event.detail});
		user = event.detail;
	});

	var hash_settings = {};

	window.Magellan = function (options) {
		options = options || {};
		options.settings = options.settings || {};

		var frameId = getFrameId();

		for (var key in DEFAULT) {
			options[key] = options[key] || DEFAULT[key];
		}

		if (window.location.hash) {
			try {
				hash_settings = JSON.parse(decodeURIComponent(window.location.hash.slice(1)));
				parent.location.hash = '';
			}
			catch (SyntaxError) {}
		}

		if (!options.ignoreSettingsFromHash) {
			options.url = hash_settings.url || options.url;
			for (var key in hash_settings)
				options.settings[key] = hash_settings[key];
		}
		options.url = options.url ? ((options.url[0] === '/') ? options.url : '/' + options.url) : '/';

		var settings = '', firstLoad = '';
		for (key in options.settings || {}) {
			if (key in FIRST_LOAD) {
				firstLoad += '&' + key + '=' + options.settings[key];
			}
			else {
				settings += '&' + key + '=' + options.settings[key];
			}
		}

		var initialize = function () {
			var el = document.getElementById(options.target);
			if (!el) throw "Can`t find base element: " + options.target;
			var width = Math.max(el.offsetWidth, MIN_SIZE.width), height = Math.max(el.offsetHeight, MIN_SIZE.height);
			var frame = document.createElement('iframe');
			frame.id = frameId;
			var url = window.localStorage.getItem(LOCALSTORAGE_PREFIX + 'Redirect') || baseUrl + options.url;
			localStorage.removeItem(LOCALSTORAGE_PREFIX + 'Redirect');
			frame.src = url + '?id=' + frameId + settings + firstLoad;
			frame.setAttribute('frameborder', '0');
			frame.setAttribute('style', 'width:' + width + 'px;height:' + height + 'px;overflow: hidden;');
			el.outerHTML = frame.outerHTML;
			frames[frameId] = {el: document.getElementById(frameId), settings: settings};
		};

		if (document.readyState != 'loading') initialize();
		else document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanLoginButton = function (target) {
		target = target || 'magellan-login';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				showFixed(baseUrl + '/auth-popup', 'auth-popup');
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanLogoutButton = function (target) {
		target = target || 'magellan-logout';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				addServiceFrame('logout-frame');
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanSearchButton = function (url, target) {
		target = target || 'magellan-search';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				window.localStorage.setItem(LOCALSTORAGE_PREFIX + 'Redirect', baseUrl);
				window.location = url;
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanToursSearchButton = function (url, target) {
		target = target || 'magellan-tours-search';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				window.localStorage.setItem(LOCALSTORAGE_PREFIX + 'Redirect', baseUrl + '/tours-search');
				window.location = url;
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanAvailabilityButton = function (url, target) {
		target = target || 'magellan-availability';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				window.localStorage.setItem(LOCALSTORAGE_PREFIX + 'Redirect', baseUrl + '/availability');
				window.location = url;
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanOrdersButton = function (url, target) {
		target = target || 'magellan-orders';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				checkMagellanUser(function (user) {
					if (user) {
						window.localStorage.setItem(LOCALSTORAGE_PREFIX + 'Redirect', user.api + '/orders');
						window.location = url;
					}
				});
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.initMagellanSettingsButton = function (url, target) {
		target = target || 'magellan-settings';
		var initialize = function () {
			var el = document.getElementById(target);
			if (!el) throw "Can`t find target element: " + target;
			el.addEventListener("click", function () {
				checkMagellanUser(function (user) {
					if (user) {
						window.localStorage.setItem(LOCALSTORAGE_PREFIX + 'Redirect', user.api + '/settings');
						window.location = url;
					}
				});
			});
		};

		if (document.readyState != 'loading') initialize();
		document.addEventListener('DOMContentLoaded', initialize);
	};

	window.checkMagellanUser = function (callback) {
		if (typeof user == 'undefined') {
			userInfoCallback = callback;
			addServiceFrame('user-info-frame');
		}
		else {
			callback(user);
		}
	};

	try {
		new CustomEvent("Polyfill CustomEvent for IE9+");
	}
	catch (e) {
		window.CustomEvent = function (event, params) {
			params = params || {bubbles: false, cancelable: false, detail: undefined};
			var evt = document.createEvent("CustomEvent");
			evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
			return evt;
		};
		CustomEvent.prototype = Object.create(window.Event.prototype);
	}
})();


/***/ })

/******/ });


// WEBPACK FOOTER //
// magellan.js